<template>
  <v-card :loading="loading">
    <v-card-text class="pa-2 caption black--text">
      <apexchart type="bar" :height="height" :options="chartOptions" :series="series" />
    </v-card-text>
  </v-card>
</template>

<script>
import helper from '../../../plugins/helpers/mixin-helper'
export default {
  mixins: [
    helper
  ],
  props: {
    title: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      default: () => []
    },
    categories: {
      type: Array,
      default: () => []
    },
  },
  data () {
    return {
      loading: false,
      chartOptions: {
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%',
          animations: {
            enabled: false
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: this.title
        },
        colors: this.generateColorsByLength(this.series.length),
        xaxis: {
          categories: this.categories,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      }
    }
  },
  watch: {
    categories (val) {
      this.chartOptions = {
        ...this.chartOptions,
        xaxis: {
          categories: val
        }
      }
    }
  },
  computed: {
    height () {
      return 150 + this.categories.length * 20
    }
  }
}
</script>
